// semantic.ts
export const semanticTokens = {
  "semantic": {
    "common": {
      "feedback": {
        "success": {
          "value": "#0fa15f",
          "type": "color",
          "filePath": "design-tokens/semantic.json",
          "isSource": true,
          "original": {
            "value": "{color.success.500}",
            "type": "color"
          },
          "name": "SemanticCommonFeedbackSuccess",
          "attributes": {
            "category": "semantic",
            "type": "common",
            "item": "feedback",
            "subitem": "success"
          },
          "path": [
            "semantic",
            "common",
            "feedback",
            "success"
          ]
        },
        "info": {
          "value": "#ff6801",
          "type": "color",
          "filePath": "design-tokens/semantic.json",
          "isSource": true,
          "original": {
            "value": "{color.primary.500}",
            "type": "color"
          },
          "name": "SemanticCommonFeedbackInfo",
          "attributes": {
            "category": "semantic",
            "type": "common",
            "item": "feedback",
            "subitem": "info"
          },
          "path": [
            "semantic",
            "common",
            "feedback",
            "info"
          ]
        },
        "warning": {
          "value": "#ffb300",
          "type": "color",
          "filePath": "design-tokens/semantic.json",
          "isSource": true,
          "original": {
            "value": "{color.warning.500}",
            "type": "color"
          },
          "name": "SemanticCommonFeedbackWarning",
          "attributes": {
            "category": "semantic",
            "type": "common",
            "item": "feedback",
            "subitem": "warning"
          },
          "path": [
            "semantic",
            "common",
            "feedback",
            "warning"
          ]
        },
        "help": {
          "value": "#ff9952",
          "type": "color",
          "filePath": "design-tokens/semantic.json",
          "isSource": true,
          "original": {
            "value": "{color.primary.300}",
            "type": "color"
          },
          "name": "SemanticCommonFeedbackHelp",
          "attributes": {
            "category": "semantic",
            "type": "common",
            "item": "feedback",
            "subitem": "help"
          },
          "path": [
            "semantic",
            "common",
            "feedback",
            "help"
          ]
        },
        "danger": {
          "value": "#cc2929",
          "type": "color",
          "filePath": "design-tokens/semantic.json",
          "isSource": true,
          "original": {
            "value": "{color.error.500}",
            "type": "color"
          },
          "name": "SemanticCommonFeedbackDanger",
          "attributes": {
            "category": "semantic",
            "type": "common",
            "item": "feedback",
            "subitem": "danger"
          },
          "path": [
            "semantic",
            "common",
            "feedback",
            "danger"
          ]
        },
        "secondary": {
          "value": "#5c5c5c",
          "type": "color",
          "filePath": "design-tokens/semantic.json",
          "isSource": true,
          "original": {
            "value": "{color.neutral.500}",
            "type": "color"
          },
          "name": "SemanticCommonFeedbackSecondary",
          "attributes": {
            "category": "semantic",
            "type": "common",
            "item": "feedback",
            "subitem": "secondary"
          },
          "path": [
            "semantic",
            "common",
            "feedback",
            "secondary"
          ]
        }
      },
      "button": {
        "disabled": {
          "background": {
            "value": "#d2d2d2",
            "type": "color",
            "filePath": "design-tokens/semantic.json",
            "isSource": true,
            "original": {
              "value": "{color.neutral.100}",
              "type": "color"
            },
            "name": "SemanticCommonButtonDisabledBackground",
            "attributes": {
              "category": "semantic",
              "type": "common",
              "item": "button",
              "subitem": "disabled",
              "state": "background"
            },
            "path": [
              "semantic",
              "common",
              "button",
              "disabled",
              "background"
            ]
          },
          "text": {
            "value": "#7a7a7a",
            "type": "color",
            "filePath": "design-tokens/semantic.json",
            "isSource": true,
            "original": {
              "value": "{color.neutral.400}",
              "type": "color"
            },
            "name": "SemanticCommonButtonDisabledText",
            "attributes": {
              "category": "semantic",
              "type": "common",
              "item": "button",
              "subitem": "disabled",
              "state": "text"
            },
            "path": [
              "semantic",
              "common",
              "button",
              "disabled",
              "text"
            ]
          },
          "border": {
            "value": "#d2d2d2",
            "type": "color",
            "filePath": "design-tokens/semantic.json",
            "isSource": true,
            "original": {
              "value": "{color.neutral.100}",
              "type": "color"
            },
            "name": "SemanticCommonButtonDisabledBorder",
            "attributes": {
              "category": "semantic",
              "type": "common",
              "item": "button",
              "subitem": "disabled",
              "state": "border"
            },
            "path": [
              "semantic",
              "common",
              "button",
              "disabled",
              "border"
            ]
          }
        },
        "iconBorder": {
          "value": "#b5b5b5",
          "type": "color",
          "filePath": "design-tokens/semantic.json",
          "isSource": true,
          "original": {
            "value": "{color.neutral.200}",
            "type": "color"
          },
          "name": "SemanticCommonButtonIconBorder",
          "attributes": {
            "category": "semantic",
            "type": "common",
            "item": "button",
            "subitem": "iconBorder"
          },
          "path": [
            "semantic",
            "common",
            "button",
            "iconBorder"
          ]
        }
      }
    },
    "light": {
      "text": {
        "primary": {
          "value": "#373737",
          "type": "color",
          "filePath": "design-tokens/semantic.json",
          "isSource": true,
          "original": {
            "value": "{color.neutral.700}",
            "type": "color"
          },
          "name": "SemanticLightTextPrimary",
          "attributes": {
            "category": "semantic",
            "type": "light",
            "item": "text",
            "subitem": "primary"
          },
          "path": [
            "semantic",
            "light",
            "text",
            "primary"
          ]
        },
        "secondary": {
          "value": "#5c5c5c",
          "type": "color",
          "filePath": "design-tokens/semantic.json",
          "isSource": true,
          "original": {
            "value": "{color.neutral.500}",
            "type": "color"
          },
          "name": "SemanticLightTextSecondary",
          "attributes": {
            "category": "semantic",
            "type": "light",
            "item": "text",
            "subitem": "secondary"
          },
          "path": [
            "semantic",
            "light",
            "text",
            "secondary"
          ]
        },
        "inverse": {
          "value": "#e1e1e1",
          "type": "color",
          "filePath": "design-tokens/semantic.json",
          "isSource": true,
          "original": {
            "value": "{color.neutral.50}",
            "type": "color"
          },
          "name": "SemanticLightTextInverse",
          "attributes": {
            "category": "semantic",
            "type": "light",
            "item": "text",
            "subitem": "inverse"
          },
          "path": [
            "semantic",
            "light",
            "text",
            "inverse"
          ]
        }
      },
      "surface": {
        "background": {
          "value": "#e1e1e1",
          "type": "color",
          "filePath": "design-tokens/semantic.json",
          "isSource": true,
          "original": {
            "value": "{color.neutral.50}",
            "type": "color"
          },
          "name": "SemanticLightSurfaceBackground",
          "attributes": {
            "category": "semantic",
            "type": "light",
            "item": "surface",
            "subitem": "background"
          },
          "path": [
            "semantic",
            "light",
            "surface",
            "background"
          ]
        },
        "card": {
          "value": "#e1e1e1",
          "type": "color",
          "filePath": "design-tokens/semantic.json",
          "isSource": true,
          "original": {
            "value": "{color.neutral.50}",
            "type": "color"
          },
          "name": "SemanticLightSurfaceCard",
          "attributes": {
            "category": "semantic",
            "type": "light",
            "item": "surface",
            "subitem": "card"
          },
          "path": [
            "semantic",
            "light",
            "surface",
            "card"
          ]
        },
        "section": {
          "value": "#d2d2d2",
          "type": "color",
          "filePath": "design-tokens/semantic.json",
          "isSource": true,
          "original": {
            "value": "{color.neutral.100}",
            "type": "color"
          },
          "name": "SemanticLightSurfaceSection",
          "attributes": {
            "category": "semantic",
            "type": "light",
            "item": "surface",
            "subitem": "section"
          },
          "path": [
            "semantic",
            "light",
            "surface",
            "section"
          ]
        },
        "sidebarBorder": {
          "value": "#b5b5b5",
          "type": "color",
          "filePath": "design-tokens/semantic.json",
          "isSource": true,
          "original": {
            "value": "{color.neutral.200}",
            "type": "color"
          },
          "name": "SemanticLightSurfaceSidebarBorder",
          "attributes": {
            "category": "semantic",
            "type": "light",
            "item": "surface",
            "subitem": "sidebarBorder"
          },
          "path": [
            "semantic",
            "light",
            "surface",
            "sidebarBorder"
          ]
        }
      },
      "button": {
        "primary": {
          "background": {
            "value": "#ff6801",
            "type": "color",
            "filePath": "design-tokens/semantic.json",
            "isSource": true,
            "original": {
              "value": "{color.primary.500}",
              "type": "color"
            },
            "name": "SemanticLightButtonPrimaryBackground",
            "attributes": {
              "category": "semantic",
              "type": "light",
              "item": "button",
              "subitem": "primary",
              "state": "background"
            },
            "path": [
              "semantic",
              "light",
              "button",
              "primary",
              "background"
            ]
          },
          "backgroundHover": {
            "value": "#ffdcc2",
            "type": "color",
            "filePath": "design-tokens/semantic.json",
            "isSource": true,
            "original": {
              "value": "{color.primary.100}",
              "type": "color"
            },
            "name": "SemanticLightButtonPrimaryBackgroundHover",
            "attributes": {
              "category": "semantic",
              "type": "light",
              "item": "button",
              "subitem": "primary",
              "state": "backgroundHover"
            },
            "path": [
              "semantic",
              "light",
              "button",
              "primary",
              "backgroundHover"
            ]
          },
          "border": {
            "value": "#d95900",
            "type": "color",
            "filePath": "design-tokens/semantic.json",
            "isSource": true,
            "original": {
              "value": "{color.primary.600}",
              "type": "color"
            },
            "name": "SemanticLightButtonPrimaryBorder",
            "attributes": {
              "category": "semantic",
              "type": "light",
              "item": "button",
              "subitem": "primary",
              "state": "border"
            },
            "path": [
              "semantic",
              "light",
              "button",
              "primary",
              "border"
            ]
          },
          "text": {
            "value": "#e1e1e1",
            "type": "color",
            "filePath": "design-tokens/semantic.json",
            "isSource": true,
            "original": {
              "value": "{semantic.light.text.inverse}",
              "type": "color"
            },
            "name": "SemanticLightButtonPrimaryText",
            "attributes": {
              "category": "semantic",
              "type": "light",
              "item": "button",
              "subitem": "primary",
              "state": "text"
            },
            "path": [
              "semantic",
              "light",
              "button",
              "primary",
              "text"
            ]
          }
        },
        "secondary": {
          "background": {
            "value": "#e1e1e1",
            "type": "color",
            "filePath": "design-tokens/semantic.json",
            "isSource": true,
            "original": {
              "value": "#e1e1e1",
              "type": "color"
            },
            "name": "SemanticLightButtonSecondaryBackground",
            "attributes": {
              "category": "semantic",
              "type": "light",
              "item": "button",
              "subitem": "secondary",
              "state": "background"
            },
            "path": [
              "semantic",
              "light",
              "button",
              "secondary",
              "background"
            ]
          },
          "backgroundMuted": {
            "value": "#ffdcc2",
            "type": "color",
            "filePath": "design-tokens/semantic.json",
            "isSource": true,
            "original": {
              "value": "{color.primary.100}",
              "type": "color"
            },
            "name": "SemanticLightButtonSecondaryBackgroundMuted",
            "attributes": {
              "category": "semantic",
              "type": "light",
              "item": "button",
              "subitem": "secondary",
              "state": "backgroundMuted"
            },
            "path": [
              "semantic",
              "light",
              "button",
              "secondary",
              "backgroundMuted"
            ]
          },
          "border": {
            "value": "#ff7f26",
            "type": "color",
            "filePath": "design-tokens/semantic.json",
            "isSource": true,
            "original": {
              "value": "{color.primary.400}",
              "type": "color"
            },
            "name": "SemanticLightButtonSecondaryBorder",
            "attributes": {
              "category": "semantic",
              "type": "light",
              "item": "button",
              "subitem": "secondary",
              "state": "border"
            },
            "path": [
              "semantic",
              "light",
              "button",
              "secondary",
              "border"
            ]
          },
          "text": {
            "value": "#d95900",
            "type": "color",
            "filePath": "design-tokens/semantic.json",
            "isSource": true,
            "original": {
              "value": "{color.primary.600}",
              "type": "color"
            },
            "name": "SemanticLightButtonSecondaryText",
            "attributes": {
              "category": "semantic",
              "type": "light",
              "item": "button",
              "subitem": "secondary",
              "state": "text"
            },
            "path": [
              "semantic",
              "light",
              "button",
              "secondary",
              "text"
            ]
          }
        },
        "tertiary": {
          "background": {
            "value": "#d2d2d2",
            "type": "color",
            "filePath": "design-tokens/semantic.json",
            "isSource": true,
            "original": {
              "value": "{color.neutral.100}",
              "type": "color"
            },
            "name": "SemanticLightButtonTertiaryBackground",
            "attributes": {
              "category": "semantic",
              "type": "light",
              "item": "button",
              "subitem": "tertiary",
              "state": "background"
            },
            "path": [
              "semantic",
              "light",
              "button",
              "tertiary",
              "background"
            ]
          },
          "text": {
            "value": "#373737",
            "type": "color",
            "filePath": "design-tokens/semantic.json",
            "isSource": true,
            "original": {
              "value": "{color.neutral.700}",
              "type": "color"
            },
            "name": "SemanticLightButtonTertiaryText",
            "attributes": {
              "category": "semantic",
              "type": "light",
              "item": "button",
              "subitem": "tertiary",
              "state": "text"
            },
            "path": [
              "semantic",
              "light",
              "button",
              "tertiary",
              "text"
            ]
          }
        }
      }
    },
    "dark": {
      "text": {
        "primary": {
          "value": "#d2d2d2",
          "type": "color",
          "filePath": "design-tokens/semantic.json",
          "isSource": true,
          "original": {
            "value": "{color.neutral.100}",
            "type": "color"
          },
          "name": "SemanticDarkTextPrimary",
          "attributes": {
            "category": "semantic",
            "type": "dark",
            "item": "text",
            "subitem": "primary"
          },
          "path": [
            "semantic",
            "dark",
            "text",
            "primary"
          ]
        },
        "secondary": {
          "value": "#7a7a7a",
          "type": "color",
          "filePath": "design-tokens/semantic.json",
          "isSource": true,
          "original": {
            "value": "{color.neutral.400}",
            "type": "color"
          },
          "name": "SemanticDarkTextSecondary",
          "attributes": {
            "category": "semantic",
            "type": "dark",
            "item": "text",
            "subitem": "secondary"
          },
          "path": [
            "semantic",
            "dark",
            "text",
            "secondary"
          ]
        },
        "inverse": {
          "value": "#121212",
          "type": "color",
          "filePath": "design-tokens/semantic.json",
          "isSource": true,
          "original": {
            "value": "{color.neutral.900}",
            "type": "color"
          },
          "name": "SemanticDarkTextInverse",
          "attributes": {
            "category": "semantic",
            "type": "dark",
            "item": "text",
            "subitem": "inverse"
          },
          "path": [
            "semantic",
            "dark",
            "text",
            "inverse"
          ]
        }
      },
      "surface": {
        "background": {
          "value": "#121212",
          "type": "color",
          "filePath": "design-tokens/semantic.json",
          "isSource": true,
          "original": {
            "value": "{color.neutral.900}",
            "type": "color"
          },
          "name": "SemanticDarkSurfaceBackground",
          "attributes": {
            "category": "semantic",
            "type": "dark",
            "item": "surface",
            "subitem": "background"
          },
          "path": [
            "semantic",
            "dark",
            "surface",
            "background"
          ]
        },
        "card": {
          "value": "#252525",
          "type": "color",
          "filePath": "design-tokens/semantic.json",
          "isSource": true,
          "original": {
            "value": "{color.neutral.800}",
            "type": "color"
          },
          "name": "SemanticDarkSurfaceCard",
          "attributes": {
            "category": "semantic",
            "type": "dark",
            "item": "surface",
            "subitem": "card"
          },
          "path": [
            "semantic",
            "dark",
            "surface",
            "card"
          ]
        },
        "section": {
          "value": "#252525",
          "type": "color",
          "filePath": "design-tokens/semantic.json",
          "isSource": true,
          "original": {
            "value": "{color.neutral.800}",
            "type": "color"
          },
          "name": "SemanticDarkSurfaceSection",
          "attributes": {
            "category": "semantic",
            "type": "dark",
            "item": "surface",
            "subitem": "section"
          },
          "path": [
            "semantic",
            "dark",
            "surface",
            "section"
          ]
        },
        "sidebarBorder": {
          "value": "#373737",
          "type": "color",
          "filePath": "design-tokens/semantic.json",
          "isSource": true,
          "original": {
            "value": "{color.neutral.700}",
            "type": "color"
          },
          "name": "SemanticDarkSurfaceSidebarBorder",
          "attributes": {
            "category": "semantic",
            "type": "dark",
            "item": "surface",
            "subitem": "sidebarBorder"
          },
          "path": [
            "semantic",
            "dark",
            "surface",
            "sidebarBorder"
          ]
        }
      },
      "button": {
        "primary": {
          "background": {
            "value": "#ff6801",
            "type": "color",
            "filePath": "design-tokens/semantic.json",
            "isSource": true,
            "original": {
              "value": "{color.primary.500}",
              "type": "color"
            },
            "name": "SemanticDarkButtonPrimaryBackground",
            "attributes": {
              "category": "semantic",
              "type": "dark",
              "item": "button",
              "subitem": "primary",
              "state": "background"
            },
            "path": [
              "semantic",
              "dark",
              "button",
              "primary",
              "background"
            ]
          },
          "backgroundHover": {
            "value": "#ffdcc2",
            "type": "color",
            "filePath": "design-tokens/semantic.json",
            "isSource": true,
            "original": {
              "value": "{color.primary.100}",
              "type": "color"
            },
            "name": "SemanticDarkButtonPrimaryBackgroundHover",
            "attributes": {
              "category": "semantic",
              "type": "dark",
              "item": "button",
              "subitem": "primary",
              "state": "backgroundHover"
            },
            "path": [
              "semantic",
              "dark",
              "button",
              "primary",
              "backgroundHover"
            ]
          },
          "border": {
            "value": "#d95900",
            "type": "color",
            "filePath": "design-tokens/semantic.json",
            "isSource": true,
            "original": {
              "value": "{color.primary.600}",
              "type": "color"
            },
            "name": "SemanticDarkButtonPrimaryBorder",
            "attributes": {
              "category": "semantic",
              "type": "dark",
              "item": "button",
              "subitem": "primary",
              "state": "border"
            },
            "path": [
              "semantic",
              "dark",
              "button",
              "primary",
              "border"
            ]
          },
          "text": {
            "value": "#e1e1e1",
            "type": "color",
            "filePath": "design-tokens/semantic.json",
            "isSource": true,
            "original": {
              "value": "{color.neutral.50}",
              "type": "color"
            },
            "name": "SemanticDarkButtonPrimaryText",
            "attributes": {
              "category": "semantic",
              "type": "dark",
              "item": "button",
              "subitem": "primary",
              "state": "text"
            },
            "path": [
              "semantic",
              "dark",
              "button",
              "primary",
              "text"
            ]
          }
        },
        "secondary": {
          "background": {
            "value": "#121212",
            "type": "color",
            "filePath": "design-tokens/semantic.json",
            "isSource": true,
            "original": {
              "value": "{color.neutral.900}",
              "type": "color"
            },
            "name": "SemanticDarkButtonSecondaryBackground",
            "attributes": {
              "category": "semantic",
              "type": "dark",
              "item": "button",
              "subitem": "secondary",
              "state": "background"
            },
            "path": [
              "semantic",
              "dark",
              "button",
              "secondary",
              "background"
            ]
          },
          "backgroundMuted": {
            "value": "#a84800",
            "type": "color",
            "filePath": "design-tokens/semantic.json",
            "isSource": true,
            "original": {
              "value": "{color.primary.700}",
              "type": "color"
            },
            "name": "SemanticDarkButtonSecondaryBackgroundMuted",
            "attributes": {
              "category": "semantic",
              "type": "dark",
              "item": "button",
              "subitem": "secondary",
              "state": "backgroundMuted"
            },
            "path": [
              "semantic",
              "dark",
              "button",
              "secondary",
              "backgroundMuted"
            ]
          },
          "border": {
            "value": "#ff7f26",
            "type": "color",
            "filePath": "design-tokens/semantic.json",
            "isSource": true,
            "original": {
              "value": "{color.primary.400}",
              "type": "color"
            },
            "name": "SemanticDarkButtonSecondaryBorder",
            "attributes": {
              "category": "semantic",
              "type": "dark",
              "item": "button",
              "subitem": "secondary",
              "state": "border"
            },
            "path": [
              "semantic",
              "dark",
              "button",
              "secondary",
              "border"
            ]
          },
          "text": {
            "value": "#ffdcc2",
            "type": "color",
            "filePath": "design-tokens/semantic.json",
            "isSource": true,
            "original": {
              "value": "{color.primary.100}",
              "type": "color"
            },
            "name": "SemanticDarkButtonSecondaryText",
            "attributes": {
              "category": "semantic",
              "type": "dark",
              "item": "button",
              "subitem": "secondary",
              "state": "text"
            },
            "path": [
              "semantic",
              "dark",
              "button",
              "secondary",
              "text"
            ]
          }
        },
        "tertiary": {
          "background": {
            "value": "#252525",
            "type": "color",
            "filePath": "design-tokens/semantic.json",
            "isSource": true,
            "original": {
              "value": "{color.neutral.800}",
              "type": "color"
            },
            "name": "SemanticDarkButtonTertiaryBackground",
            "attributes": {
              "category": "semantic",
              "type": "dark",
              "item": "button",
              "subitem": "tertiary",
              "state": "background"
            },
            "path": [
              "semantic",
              "dark",
              "button",
              "tertiary",
              "background"
            ]
          },
          "text": {
            "value": "#d2d2d2",
            "type": "color",
            "filePath": "design-tokens/semantic.json",
            "isSource": true,
            "original": {
              "value": "{color.neutral.100}",
              "type": "color"
            },
            "name": "SemanticDarkButtonTertiaryText",
            "attributes": {
              "category": "semantic",
              "type": "dark",
              "item": "button",
              "subitem": "tertiary",
              "state": "text"
            },
            "path": [
              "semantic",
              "dark",
              "button",
              "tertiary",
              "text"
            ]
          }
        }
      }
    }
  }
} as const;

export type SemanticTokens = typeof semanticTokens;
